module.exports = __webpack_public_path__ + "img/doc_item_info.ddf121b3.jpg";